import { Deserializable } from "../models/deserializable.model";

export class Form implements Deserializable {
  _id: string = '';
  name: string = '';
  campaign: string = "";
  assignment: any = [];
  listOfSplitAssigment: any = [];
  splitAssigment: any = false;
  author: string = '';
  random_assignment: any = false;
  fb_id: string = '';
  campaign_id: string = '';
  web_id: string = '';
  status: string = 'active';
  fields: any = [];

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/form/form.model.ts